import { useEffect, useState } from 'react';

// Services
import websocketConnectionManager from 'Services/websocketConnectionManager';

// Config
import { CallbackActions } from 'Config/websocketConstants';

const useWebsocketConnection = (clientName, actionToCallbackObj) => {
  const [wsConnectionStatus, setWsConnectionStatus] = useState(websocketConnectionManager.connectionStatus);

  const updateWsConnectionStatus = (newStatus) => {
    setWsConnectionStatus(newStatus);
  }

  useEffect(() => {
    websocketConnectionManager.connect(clientName);
    websocketConnectionManager.addActionCallback(CallbackActions.WS_STATUS_UPDATE, updateWsConnectionStatus);

    return () => {
        websocketConnectionManager.deleteActionCallback(CallbackActions.WS_STATUS_UPDATE, updateWsConnectionStatus);
        websocketConnectionManager.disconnect(clientName);
    }
  }, [clientName]);

  useEffect(() => {
    if (actionToCallbackObj) {
        for (const action in actionToCallbackObj) {
            websocketConnectionManager.addActionCallback(action, actionToCallbackObj[action]);
        }
    }

    return () => {
        if (actionToCallbackObj) {
            for (const action in actionToCallbackObj) {
                websocketConnectionManager.deleteActionCallback(action, actionToCallbackObj[action]);
            }
        }
    }
  }, [actionToCallbackObj]);

  const sendPayload = (payload) => {
    websocketConnectionManager.sendPayload(payload);
  }

  return { wsConnectionStatus, sendPayload };
};

export default useWebsocketConnection;